let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Sv7r")).then(() => parcelRequire('125bR'));